import React, {useCallback} from 'react'
import {NavigatorForMemberPage} from '../../../Navigator/NavigatorForMemberPage'
import {MembersPageTemplate} from '../../Molecules/BaseMembersPages/MembersPageTemplate'
import {PageTitle} from '../../Molecules/BaseMembersPages/PageTitle'
import StepGuide from '../../Molecules/StepGuide/StepGuide'
import {ContentTitle} from '../../Molecules/BaseContentBlocks/ContentTitle'
import {Spacer} from '../../../../Common/Components/Spacer'
import {ContentTopMessage} from '../../Molecules/BaseContentBlocks/ContentTopMessage'
import {ContentBlock} from '../../Molecules/BaseContentBlocks/ContentBlock'
import {PIMPageActions} from '../../Atoms/Layouts/PIMPageActions'
import {PIMSecondaryButton} from '../../Atoms/Buttons/Bases/PIMSecondaryButton'
import {useTranslation} from 'react-i18next'

type MembersEditShippingAddressCompletePageProps = {
  navigator: NavigatorForMemberPage
}
export const MembersEditShippingAddressCompletePage:
  React.VFC<MembersEditShippingAddressCompletePageProps> = (
  {
    navigator,
  },
) => {
  const {t} = useTranslation('member')

  const goToAccountTopPage = useCallback((): void => {
    navigator.goToAccountTopPage()
  }, [navigator])

  return (
    <MembersPageTemplate>
      <PageTitle>商品配送先情報変更完了</PageTitle>

      <StepGuide activity={'edit'} current={'complete'}/>

      <ContentBlock data-testid={'block-notification'}>
        <ContentTitle>商品配送先情報変更完了</ContentTitle>
        <Spacer mb={'16px'}>
          <ContentTopMessage>
            商品配送先情報変更を行いました。<br/>
            ご登録されているメールアドレスに完了通知を送信しました。
          </ContentTopMessage>
        </Spacer>
      </ContentBlock>

      <Spacer mt={'30px'}>
        <PIMPageActions>
          <PIMSecondaryButton onClick={goToAccountTopPage}>
            {t('MYアカウント.ページ名')}に移動する
          </PIMSecondaryButton>
        </PIMPageActions>
      </Spacer>
    </MembersPageTemplate>
  )
}
